export interface SalesModelPolicyValue {
  model_id?: unknown;
  name?: unknown;
  aliases?: readonly unknown[];
  active?: unknown;
}

export const RETIRED_FOLLOWME_PRO_M7_43_BLACK_ID = 'FOLLOWME_PRO_M7_43_BLACK';

function normalizedPolicyText(value: unknown): string {
  return String(value || '').normalize('NFKC').toUpperCase();
}

function isBlackProM743Label(value: unknown): boolean {
  const compact = normalizedPolicyText(value).replace(/[^A-Z0-9\u4E00-\u9FFF]+/g, '');
  return compact.includes('PRO')
    && compact.includes('M7')
    && compact.includes('43')
    && (compact.includes('BLACK') || compact.includes('黑'));
}

/**
 * This business combination never existed. Keep recognizing its historical ID
 * and label variants so no catalog source or client can re-enable it.
 */
export function isRetiredSalesModel(model: SalesModelPolicyValue | null | undefined): boolean {
  if (!model) return false;
  if (normalizedPolicyText(model.model_id) === RETIRED_FOLLOWME_PRO_M7_43_BLACK_ID) return true;
  return [model.model_id, model.name, ...(Array.isArray(model.aliases) ? model.aliases : [])]
    .some(isBlackProM743Label);
}

export function isSelectableSalesModel(model: SalesModelPolicyValue | null | undefined): boolean {
  return Boolean(model?.active) && !isRetiredSalesModel(model);
}

export function forceRetiredSalesModelInactive<T extends SalesModelPolicyValue & { active: boolean }>(model: T): T {
  return isRetiredSalesModel(model) && model.active ? { ...model, active: false } : model;
}
